import React, { ReactNode, ReactChild } from 'react';

import { wrapModalPromise, WrapModalProps } from 'utils';

import './index.css';

interface AsyncConfirmModalProps {
  title?: ReactNode;
  children?: ReactChild;
}

export const AsyncConfirmModal = ({
  title,
  children,
  hide,
  onResolve,
  onReject,
}: AsyncConfirmModalProps & WrapModalProps) => {
  return (
    <div className="db-modal db-confirmModal">
      {title && <div className="db-asyncConfirmModal-title">{title}</div>}
      {children && React.isValidElement(children)
        ? React.cloneElement(children, {
            //@ts-ignore
            hide,
            onResolve,
            onReject,
          })
        : null}
    </div>
  );
};

export const asyncConfirm = wrapModalPromise<AsyncConfirmModalProps>(AsyncConfirmModal);
